import { useQuery } from 'apollo-3';

import { useClassroomContext } from 'Context/ClassroomContext';
import { myCourse } from 'GraphQL/query/Product.query';

const useMyCourseData = ({ ...props }) => {
  const { courseId } = useClassroomContext();

  const { data, loading, error, ...apolloUtils } = useQuery(myCourse, {
    variables: { courseId },
    ...props,
  });

  return {
    data: data?.myCourse,
    courseCode: data?.myCourse?.courseInfo?.courseCode,
    discussUrl: data?.myCourse?.courseInfo?.discussUrl,
    loading,
    error,
    ...apolloUtils,
  };
};

export default useMyCourseData;
